import {STEP_ADDRESS, STEP_PAYMENT} from "../Constants";

/**
 * @param {CheckoutState} state
 * @param {string} target
 */
export function goto(state, target) {
    if (state.step === target) return;
    if (state.paymentProviderChangeModeEnabled && !state.allowCancellation && [STEP_ADDRESS, STEP_PAYMENT].includes(target)) return;
    state.setStep(target);
}
